import { useSearchParams, useNavigate } from 'react-router-dom'
import { ArrowLeft, ShieldCheck } from 'lucide-react'

export default function PortalVisioPage() {
    const[searchParams] = useSearchParams()
    const navigate = useNavigate()
    const room = searchParams.get('room')

    if (!room) {
        return <div className="p-8 text-center text-red-500">Salon introuvable.</div>
    }

    return (
        <div className="fixed inset-0 bg-gray-900 z-[100] flex flex-col">
            
            {/* Header Sombre */}
            <div className="bg-gray-900 text-white p-4 flex items-center justify-between shadow-md z-10">
                <button 
                    onClick={() => navigate(-1)} 
                    className="p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition-colors"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
                <div className="flex flex-col items-center">
                    <span className="font-bold text-sm">Téléconsultation</span>
                    <span className="text-[10px] text-gray-400 flex items-center gap-1">
                        <ShieldCheck className="w-3 h-3" /> Chiffré de bout en bout
                    </span>
                </div>
                <div className="w-9 h-9" /> {/* Spacer pour centrer le texte */}
            </div>

            {/* iFrame Jitsi Meet */}
            <div className="flex-1 w-full bg-black relative">
                <iframe
                    allow="camera; microphone; display-capture; fullscreen"
                    src={`https://meet.jit.si/BellaBlue-${room}?lang=fr#config.disableDeepLinking=true`}
                    style={{ width: '100%', height: '100%', border: '0px' }}
                />
            </div>
        </div>
    )
}